import { useReducer, useCallback } from 'react'
import { ShipmentIssueType } from 'apps/marketplace/apiTypes/shipmentIssues'
import { MODAL_TYPE } from '../ControlPanelIssueTypeModal'

interface IIssueTypeModalState {
  issueTypeId: string | number | null
  modalType: keyof typeof MODAL_TYPE | null
}

interface ITumblrPayload {
  issueTypeId?: string | number | null
  modalType?: keyof typeof MODAL_TYPE | null
}

const reducer = (state: IIssueTypeModalState, payload: ITumblrPayload): IIssueTypeModalState => ({
  ...state,
  ...payload,
})

const initialState = {
  issueTypeId: null,
  modalType: null,
}

/**
 * Hook that handles the Issue Type modal, Create Issue Type and Edit Issue Type
 * Manages state for opening/closing and passing down the selected Issue Type to the modal
 * @param {ShipmentIssueType[]} issueTypes
 * @returns {IUseIssueTypeModal}
 */
const useIssueTypeModal = (issueTypes: ShipmentIssueType[] = []) => {
  const [state, setState] = useReducer(reducer, initialState)
  const toggleIssueTypeModal = useCallback(
    (modalType?: keyof typeof MODAL_TYPE, issueTypeId?: string | number) => {
      setState({
        modalType: modalType || null,
        issueTypeId: issueTypeId || null,
      })
    },
    []
  )

  const selectedIssueType = issueTypes.find(({ id }) => id === state.issueTypeId)

  return {
    issueTypeId: state.issueTypeId,
    modalType: state.modalType,
    isModalOpen: !!state.modalType,
    toggleIssueTypeModal,
    selectedIssueType,
  }
}

export default useIssueTypeModal
